import { FlaskConical, Package, Wrench } from 'lucide-react';

import { TabsContent } from '@/components/ui/tabs';

import { ContextSelectionType } from '@/components/chat/ContextSelectionContext';
import { ExperimentItem } from '@/components/chat/chat-context-menu/hooks/useExperiments';
import { ProductItem } from '@/components/chat/chat-context-menu/hooks/useProducts';
import { ToolItem } from '@/components/chat/chat-context-menu/hooks/useTools';
import { ChatContextMenuAllSection } from '@/components/chat/chat-context-menu/tabs/ChatContextMenuAllSection';
import { ChatContextMenuAllSuggested } from '@/components/chat/chat-context-menu/tabs/ChatContextMenuAllSuggested';

interface ChatContextMenuAllTabProps {
  loadingProducts: boolean;
  loadingTools: boolean;
  loadingExperiments: boolean;
  products: ProductItem[];
  tools: ToolItem[];
  experiments: ExperimentItem[];
}

export const ChatContextMenuAllTab = ({
  loadingProducts,
  loadingTools,
  loadingExperiments,
  products,
  tools,
  experiments,
}: ChatContextMenuAllTabProps) => (
  <TabsContent
    value="all"
    className="mt-2 space-y-1 max-h-[320px] overflow-y-auto scrollbar-thin"
  >
    <ChatContextMenuAllSuggested tools={tools} />

    <ChatContextMenuAllSection
      icon={<Package className="h-4 w-4 text-green-600" />}
      title="Products"
      type={ContextSelectionType.Product}
      loading={loadingProducts}
      items={products}
    />

    <ChatContextMenuAllSection
      icon={<Wrench className="h-4 w-4 text-orange-500" />}
      title="Tools"
      type={ContextSelectionType.Tool}
      loading={loadingTools}
      items={tools}
    />

    <ChatContextMenuAllSection
      icon={<FlaskConical className="h-4 w-4 text-blue-500" />}
      title="Experiments"
      type={ContextSelectionType.Experiment}
      loading={loadingExperiments}
      items={experiments}
    />
  </TabsContent>
);
